import { RootState } from '../store'
import { createSelector } from '@reduxjs/toolkit'

const email = (state: RootState) => (state.user.user && state.user.user.email) || ""
const userId = (state: RootState) => state.user.user?._id || ""
const loading = (state: RootState) => state.user.loading
const error = (state: RootState) => state.user.error
const user = (state: RootState) => state.user.user

const makeUserAbbreviated = createSelector(
  [user],
  (user) => {

    if(!user) {return {name:'', city:'', state:'', zip:''}}
    return {
      first_name: user.first_name,
      last_name: user.last_name,
      full_name: `${user.first_name} ${user.last_name}`,
      city: user.address && user.address.city,
      state: user.address && user.address.state,
      zip: user.address && user.address.zip,
      short_location: user.address && `${user.address.city}, ${user.address.state} ${user.address.zip}`
    }
  }
)

// SIPP-807/808: Earthsmart refrigerator filter capture, exposed to components.
// Returns null until the user submits a matching (brand, model) via the match endpoint.
const earthsmartCapture = createSelector(
  [user],
  (user) => {
    if (!user?.earthsmart_filter_code) return null
    return {
      code: user.earthsmart_filter_code,
      brand: user.refrigerator_brand ?? '',
      model: user.refrigerator_model ?? '',
      normalizedModel: user.refrigerator_model_normalized ?? '',
      matchedAt: user.earthsmart_matched_at ?? null,
    }
  },
)

export const UserSelector = {
  email,
  userId,
  loading,
  error,
  user,
  makeUserAbbreviated,
  earthsmartCapture,
}
